<template>
    <div class="pay">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
        <div class="item_1">
            <div class="item-title">
                <h3 class="title1">支持线上+线下缴费 安全高效</h3>
            </div>
            <div class="item-contents center">
                <div class="image">
                    <ul class="infos">
                        <li v-for="x in item1_list" class="fz16">{{x.info}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="item_2">
            <div class="item-title">
                <h4 class="title1">易收宝，教培机构专属收费解决方案</h4>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="x in item2_list">
                        <img :src="x.img_" alt="">
                        <div class="title">{{x.title}}</div>
                        <div class="content">{{x.value}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item_3">
            <div class="item-title">
                <h4 class="title1">提升教培机构收费、对账效率</h4>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="x in item3_list">
                        <img :src="x.img_" alt="">
                        <div class="title">{{x.title}}</div>
                        <div class="content">{{x.value}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <shen-qing></shen-qing>
    </div>
</template>

<script>
import shenQing from "./shenqing.vue";
export default {
    components: {
        shenQing,
    },
    data(){
        return{
            item1_list:[
                {info:"线上远程支付、线下面对面支付，多种收款方式供家长选择"},
                {info:"支付宝、微信支付、信用卡、花呗等支付方式任意选，便捷灵活"},
                {info:"银行级资金保障，资金安全有保障"},
            ],
            item2_list: [
                { title: "资金安全", value: "资金由银行进行自动结算，转入机构指定账户，资金安全有保障", img_: "/static/img/product_pay/chanpin_01.png" },
                { title: "收费灵活", value: "可根据机构实际需求设置线上+线下多种收费方式，支持支付宝、微信支付、信用卡分期、花呗等多种支付方式", img_: "/static/img/product_pay/chanpin_02.png" },
                { title: "费率更低", value: "费率低至0.3%，大大低于POS机费率，每年至少节省手续费上万元", img_: "/static/img/product_pay/chanpin_03.png" },
                { title: "对账方便", value: "机构急速收费，提升家长缴费体验；系统后台自动统计，对账更方便", img_: "/static/img/product_pay/chanpin_04.png" },
            ],
            item3_list: [
                { title: "学员现场扫码缴费", value: "系统自动生成收款码，可放置在前台，也可配合“小白盒”、个人胸牌等多种收款方式，提升收费效率，避免收费高峰期家长排队等候", img_: "/static/img/product_pay/chanpin_05.png" },
                { title: "学员线上缴费", value: "机构可将课程缴费订单推送至家长手机，家长在家即可查看课程信息并缴费，无需到机构缴费，大大提升缴费体验", img_: "/static/img/product_pay/chanpin_06.png" },
                { title: "销售顾问专属收款码", value: "机构可为销售顾问生成专属收款码，系统后台自动统计每位销售顾问签单收费信息，收费情况清晰明了", img_: "/static/img/product_pay/chanpin_07.png" },
                { title: "查账、对账方便快捷", value: "系统后台自动统计订单信息、收支明细、支付方式等多维度数据，自动生成数据分析统计报告，提升财务效率", img_: "/static/img/product_pay/chanpin_08.png" },
            ],
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        openDialog:function(title,type){//type:(0机构,1微官网)
            this.$parent.$refs.openPop.openDialog(title,type);
        }
    }
}
</script>

<style scoped lang="less">
.banner {
    width: 100%;
    height: 480px;
    margin-top: 80px;
    background: url("https://cdntest.yizhiniao.com/newWebsite_/product_pay/chanpin3_banner.jpg") no-repeat center;

    .banner-center {
        height: 100%;
        position: relative;
    }

    .banner-info {
        position: absolute;
        bottom: 120px;
        left:50px;
        text-align: left;
    }
    .shenqing{
        border: none;
        color:#0F74FF;
        &:hover,&:active{
            background:#0F74FF;
            color:#fff;
        }
    }
}
.item_1{
    padding-top: 180px;
    .item-contents{
        margin-top: 80px;
        .image{
            width: 1140px;
            height: 740px;
            margin:0 auto;
            background:url("https://cdntest.yizhiniao.com/newWebsite_/product_pay/chanpin3_chahua.png") no-repeat center;
            .infos{
                margin-top:40px;
                margin-left:90px;
                    li{
                    width:290px;
                    padding-left:11px;
                    position:relative;
                    text-align:left;
                    white-space: normal;
                    &:before{
                        position: absolute;
                        top:0;
                        left: 0;
                        content:'';
                        width: 6px;
                        height: 20px;
                        background: #2C7AFD;
                        border-radius: 4px;

                    }
                    &:not(:first-child){
                        margin-top:30px;
                    }
                }
            }
        }
    }
}

.item_2,.item_3 {
        padding-top:160px;

        .item-contents {
            margin-top: 60px;

            ul {
                width: 1130px;
                margin:0 auto;
                padding-top: 20px;
                padding-bottom: 20px;
                display: flex;
                justify-content: space-between;

                li {
                    width: 260px;
                    height: 260px;
                    padding: 10px 20px 20px;
                    background: #F9FCFF;
                    border: 1px solid rgba(89, 112, 196, 0.2);

                    img {
                        width: 100px;
                        height: 100px;
                        margin: 0 auto 10px;
                    }

                    .title {
                        text-align: center;
                        color: #4A4A4A;
                        font-size: 20px;
                    }

                    .content {
                        width: 220px;
                        margin: 10px auto 0;
                        color: #9B9B9B;
                        font-size: 14px;
                        text-align: left;
                        line-height: 20px;
                    }

                    &:hover {
                        transition: 0.5s;
                        background: #FFFFFF;
                        margin-top:-10px;
                        border:none;
                        box-shadow: 0px 2px 30px 0px rgba(191, 202, 214, 0.5);
                    }
                }
            }
        }
    }
    .item_3{
        padding-bottom: 160px;
    }
</style>



// WEBPACK FOOTER //
// src/components/product_pay.vue